import React from 'react';
import { motion } from 'framer-motion';
import './SentosaSection.css';

const SentosaSection = () => {
  // Animation settings for consistency
  const leftVariant = {
    hidden: { opacity: 0, x: -100 },
    visible: { 
      opacity: 1, 
      x: 0, 
      transition: { duration: 0.9, ease: "easeOut" } 
    }
  };

  const rightVariant = {
    hidden: { opacity: 0, x: 100 },
    visible: { 
      opacity: 1, 
      x: 0, 
      transition: { duration: 0.9, ease: "easeOut" } 
    }
  };

  return (
    <section className="sentosa-container">
      <div className="sentosa-wrapper">
        
        {/* LEFT SIDE: IMAGE (Aapke image_d8b4bd.png ke hisaab se) */}
        <motion.div 
          className="sentosa-img-side"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          variants={leftVariant}
        >
          {/* Yahan apni image file ka path daalein */}
          <img 
            src="https://png.pngtree.com/background/20220720/original/pngtree-hd-photography-of-real-estate-buildings-picture-image_1684042.jpg" 
            alt="Sentosa Era Building" 
            className="main-building-img"
          />
        </motion.div>

        {/* RIGHT SIDE: TEXT CONTENT */}
        <motion.div 
          className="sentosa-text-side"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          variants={rightVariant}
        >
          <div className="orange-line"></div>
          <h1 className="title-text">
            THE <br />
            <span className="orange-highlight">ERA</span> <br />
            OF EVOLVING <br />
            POSSIBILITIES
          </h1>
          
          <div className="description-text">
            <p>
              <span className="drop-cap">S</span>tep into Sentosa Era, a 14-storey landmark assembled for modern lifestyles, 
              where comfort, design, and connectivity converge. These 2, 2.5, and 3 BHK residences in Moshi are 
              purposefully built to combine aesthetic elegance with 20+ meticulously picked amenities.
            </p>
            <p>
              It's a fusion of modern architecture and the city's warmth, creating a home that evolves with you and your loved ones.
            </p>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default SentosaSection;